import { cn } from '@/lib/utils'

// 4-column running-totals matrix (hours H:MM and cycles) from the redesign:
// row label | Brght Fwd | This Leg | New Total, hairline separators between
// rows. Cell editors are provided by the caller; New Total is computed text.

const gridCols = 'grid grid-cols-[88px_repeat(3,minmax(0,1fr))] items-center gap-2'

export interface HoursTableRow {
  key: string
  label: string
  broughtFwd: React.ReactNode
  thisLeg: React.ReactNode
  newTotal: string | null
}

export function HoursTable({ rows }: { rows: HoursTableRow[] }) {
  return (
    <div className="flex flex-col">
      <div className={cn(gridCols, 'min-h-10')}>
        <span />
        <span className="text-center text-xs font-semibold text-content-primary-subtle">
          Brght Fwd
        </span>
        <span className="text-center text-xs font-semibold text-content-primary-subtle">
          This Leg
        </span>
        <span className="text-center text-xs font-semibold text-content-primary-subtle">
          New Total
        </span>
      </div>
      {rows.map((row, index) => (
        <div
          key={row.key}
          className={cn(gridCols, 'min-h-12', index < rows.length - 1 && 'border-b border-border-L1')}
        >
          <span className="text-sm font-semibold text-content-primary-subtle">{row.label}</span>
          {row.broughtFwd}
          {row.thisLeg}
          <span className="text-center text-sm font-semibold text-content-info-bold">
            {row.newTotal ?? '-'}
          </span>
        </div>
      ))}
    </div>
  )
}
